import React, { useCallback, useMemo, useState, useRef } from "react";
import { useSaveChunk } from "../utils/api.js";

export const ChunkButtons = ({
  model,
  section,
  buttons,
  isLastChunk = false,
}) => {
  const saveChunk = useSaveChunk(section?.article_id);
  const [isHovered, setIsHovered] = useState(false);
  const hoverTimeoutRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    // Clear any pending timeout
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    //setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    // Don't hide if this is the last chunk - keep menu visible
    if (isLastChunk) {
      return;
    }

    hoverTimeoutRef.current = setTimeout(() => {
      //setIsHovered(false);
      hoverTimeoutRef.current = null;
    }, 250);
  }, [isLastChunk]);

  const addChunk = useCallback(
    (type) => {
      document.activeElement.blur(); // make sure the previous item blurs (ie: saves!)

      // Safety check - ensure section and model exist
      if (!section || !section.id) {
        console.error("Cannot add chunk: section is missing or has no id", {
          section,
        });
        return;
      }
      if (!model || !model.id) {
        console.error("Cannot add chunk: model is missing or has no id", {
          model,
        });
        return;
      }

      // Create the new chunk object without mutating section yet
      const newChunk = {
        content: "",
        title: type,
        order_index: model.order_index + 1,
        section_id: section.id,
        after_id: model.id,
        saveStatus: "Saving",
      };

      // Pass both the chunk and section so useSaveChunk can handle the optimistic update
      saveChunk.mutate(newChunk);
    },
    [model, section, saveChunk],
  );

  const buttonElements = useMemo(() => {
    if (buttons == null || buttons.length < 1) {
      return null;
    }

    const buttonsList = buttons.map((b, i) => {
      let label;
      let type;
      if (typeof b === "object") {
        type = b.value;
        label = b.label;
      } else {
        label = type = b;
      }
      return (
        <span className="button" key={i} onMouseDown={() => addChunk(type)}>
          {label}
        </span>
      );
    });

    return (
      <div
        className={`chunk-menu${isHovered ? " hovered" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="buttons-menu">
          <span className="insert">+</span>
          <div className="buttons">{buttonsList}</div>
        </div>
      </div>
    );
  }, [buttons, addChunk, isHovered, handleMouseEnter, handleMouseLeave]);

  if (buttonElements != null) {
    return buttonElements;
  }

  return <div></div>;
};
